import { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { useBrandConfiguration } from '../../brands/context';
import { useApis } from '../useApis';
import { useSearchTitle } from '../useSearchTitle';
import { createLastSearch } from './createLastSearch';
import { generateLastSearchesWithoutDuplicates } from './generateLastSearchWithoutDuplicates';
const MaxNumberOfLastSearches = 20;
export const useLastSearches = ({ searchModel, pageData, searchIndex, technicalUrl, }) => {
    const { lastSearchesLocalStorageKey, defaultOrder } = useBrandConfiguration();
    const { publicUri } = useApis();
    const [lastSearches = [], setLastSearches] = useLocalStorage(lastSearchesLocalStorageKey);
    const title = useSearchTitle({ searchModel, pageData, updateTrigger: searchIndex });
    useEffect(() => {
        if (searchModel && title) {
            const newSearch = createLastSearch({ publicUri, searchModel, title, technicalUrl }, defaultOrder);
            // prevent unnecessary writes to the local storage on page jumps or order change
            if (lastSearches.length > 0 && lastSearches[0]?.link === newSearch.link) {
                return;
            }
            setLastSearches(generateLastSearchesWithoutDuplicates(lastSearches, newSearch, MaxNumberOfLastSearches));
        }
        // because title is regenerated based on searchIndex we need to consider it here as well, to ensure that the correct title will be placed.
    }, [searchIndex]);
    return lastSearches;
};
